import { use$ } from "@legendapp/state/react"
import { syncStore$ } from "@/stores/sync.v2.store"
import { useMemo } from "react"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

export function useModelPreferences() {
  const nylasAccount = use$(syncStore$.userPreferences.nylasAccount)
  const nylasLastSuccessfulConnection = use$(syncStore$.userPreferences.nylasAccount?.lastSuccessfulConnection)
  const nylasLastSuccessfulConnectionFormatted = useMemo(() => {
    const convertedTime = dayjs.utc(nylasLastSuccessfulConnection).local()
    return convertedTime.format("DD/MM/YYYY")
  }, [nylasLastSuccessfulConnection])
  const isNylasConnected = use$(() => ["initializing", "valid"].includes(syncStore$.userPreferences.nylasAccount.syncState.get() ?? ""))
  const isNylasAccountDeleted = use$(() => !nylasAccount || nylasAccount.syncState === "deleted")

  return {
    nylasAccount,
    isNylasConnected,
    isNylasAccountDeleted,
    nylasLastSuccessfulConnection: nylasLastSuccessfulConnectionFormatted,
  }
}
